import type { AiContentFormOptions } from '@shared/api';

export function aiContentTypeLabel(
  type: string | null,
  options: AiContentFormOptions | undefined,
  missing: string
) {
  if (type === null) return missing;
  return options?.types.find((option) => option.value === type)?.label ?? type;
}
